<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="类型：" prop="type">
        <el-select v-model.trim="value.type" size="small" @change="resetKey" filterable style="width: 93%">
          <el-option v-for="item in dictEnum.MrElementType" :key="item.code" :label="item.code" :value="item.name" />
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="名称：" prop="name">
        <el-input maxlength="10" show-word-limit v-model.trim="value.name" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="标签：" prop="label">
        <el-input placeholder="请输入" v-model.trim="value.label" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="占位符：" prop="PlaceHolder">
        <el-input v-model.trim="value.PlaceHolder" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item name="base" title="其它：">
          <el-form-item label="必填：" prop="MustFillContent">
            <el-radio-group v-model="value.MustFillContent">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="显示为掩码：" prop="ViewSecret">
            <el-radio-group v-model="value.ViewSecret">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="禁止删除：" prop="DeleteProtect">
            <el-radio-group v-model="value.DeleteProtect">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="只读：" prop="EditProtect">
            <el-radio-group v-model="value.EditProtect">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可打印：" prop="Printable">
            <el-radio-group v-model="value.Printable">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可作为XML输出：" prop="IsNotRecordInXML">
            <el-radio-group v-model="value.IsNotRecordInXML">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="隐藏：" prop="IsCtrlHidden">
            <el-radio-group v-model="value.IsCtrlHidden">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="背景色：" prop="category">
            <el-color-picker v-model="value.BackgroundColor" size="small" />
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item name="output" title="结构化输出：">
          <el-form-item label="元素是否输出：" prop="ifExport">
            <el-radio-group v-model="value.ifExport">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="value.ifExport" label="元素前文本：" prop="exportStartTxt">
            <el-input type="text" v-model="value.exportStartTxt" clearable size="small" class="edit-thin"></el-input>
          </el-form-item>
          <el-form-item v-if="value.ifExport" label="元素后文本：" prop="exportEndTxt">
            <el-input type="text" v-model="value.exportEndTxt" clearable size="small" class="edit-thin"></el-input>
          </el-form-item>
          <el-form-item v-if="value.ifExport" label="标签是否输出：" prop="ifExportLabel">
            <el-radio-group v-model="value.ifExportLabel">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="value.ifExport && value.ifExportLabel" label="标签后文本：" prop="afterLabelTxt">
            <el-input type="text" v-model="value.afterLabelTxt" clearable size="small" class="edit-thin"></el-input>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
    </el-col>
  </el-row>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: Object,
    },
    data() {
      return {
        activeName: "base",
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "user", "deptCascade"]),
    },
    methods: {
      resetKey() {
        this.$emit("resetKey");
      },
    },
  };
</script>
